import {
  REQUEST_PARTNER_LIST_WITH_DETAILS
} from './mutation-types'

import axiosInst from '@/utility/axiosInst';

export default {
  requestPartnersWithDetails({commit}, partnerType) {
    return axiosInst.springAxiosInst.get(`/partners/get-partner-with-details/${partnerType}`)
    .then((res) => {
      commit(REQUEST_PARTNER_LIST_WITH_DETAILS, res.data)
    })
  }
}